/* English UI strings. Keys are grouped by feature.
   Domain content (course titles, names) is bilingual in the data
   itself; this file is for chrome / labels only. */
export const en = {
  brand: { name: 'Warm Paper ED', tagline: 'Emergency Department Learning' },
  nav: {
    home: 'Home',
    catalog: 'Catalog',
    learning: 'My Learning',
    wallet: 'Certificates',
    profile: 'Profile',
    courses: 'Courses',
    attend: 'Attendance',
    certs: 'Certificates',
    approve: 'Approvals',
    users: 'Users',
    verify: 'Verify',
    org: 'Organization',
    reports: 'Reports',
    dashboard: 'Dashboard',
  },
  common: {
    search: 'Search',
    all: 'All',
    enroll: 'Enroll',
    continue: 'Continue',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    approve: 'Approve',
    decline: 'Decline',
    seats: 'seats',
    hours: 'hrs',
    signOut: 'Sign out',
  },
  auth: {
    continueTelegram: 'Continue with Telegram',
    staffOnly: 'Hospital staff only · เฉพาะบุคลากร',
    valueProp: 'Your training, certificates and onsite check-ins — in one place.',
    authorize: 'Authorize',
    pending: 'Pending approval',
    exploreWhileWait: 'Explore while you wait',
  },
  roles: {
    staff: 'Staff',
    instructor: 'Instructor',
    admin: 'Admin',
    superadmin: 'Super Admin',
  },
  toast: {
    saved: 'Saved',
    issued: 'Certificate issued',
    approved: 'Approved',
  },
};

export type Dictionary = typeof en;
